import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReusableTable from "./../components/ReusableTable";
import { getApiUrl } from "./../utils/api";
import { BASE_URL } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CategoryPage = () => {
  const UserId = "66abc123def4567890abcd12";

  const [categories, setCategories] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const fetchCategories = async () => {
    try {
      const res = await fetch(getApiUrl("category-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userid: UserId }),
      });

      const data = await res.json();
      if (data.success) {
        setCategories(data.data);
      } else {
        toast.success("Categories fetched successfully!");
      }
    } catch (error) {
      toast.error("Server error! Please try again.");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleDelete = async (id) => {
    const res = await fetch(getApiUrl("category-delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userid: UserId, categoryid: id }),
    });

    const result = await res.json();

    if (result.success) {
      toast.success("Deleted Successfully!");
      fetchCategories();
    }
  };

  const openAddModal = () => {
    setEditId(null);
    formik.resetForm();
    setSelectedImage(null);
    setShowModal(true);
  };

  const openEditModal = (cat) => {
    setEditId(cat._id);
    formik.setFieldValue("name", cat.name);
    setShowModal(true);
  };

  const formik = useFormik({
    initialValues: { name: "" },

    validationSchema: Yup.object({
      name: Yup.string().required("Category name required"),
    }),

    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("userid", UserId);
      if (editId) formData.append("categoryid", editId);
      if (selectedImage) formData.append("image", selectedImage);

      const url = editId
        ? getApiUrl("category-update")
        : getApiUrl("category-add");

      const res = await fetch(url, { method: "POST", body: formData });
      const result = await res.json();

      if (result.success) {
        toast.success(editId ? "Updated Successfully!" : "Added Successfully!");
        setShowModal(false);
        fetchCategories();
      } else {
        toast.error(result.message);
      }
    },
  });

  const columns = [
    { name: "Name", selector: (row) => row.name },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={`${BASE_URL}${row.imageUrl}`}
          alt="category"
          width="60"
          height="60"
          className="rounded border"
        />
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            className="btn btn-warning btn-sm me-2"
            onClick={() => openEditModal(row)}
          >
            <i className="fa-regular fa-pen-to-square"></i>
          </button>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(row._id)}
          >
            <i className="fa-regular fa-trash-can"></i>
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <ToastContainer position="top-right" autoClose={5000} />
      <div className="d-flex justify-content-between mb-3">
        <h3 className="fw-bold">Category Management</h3>
        <button className="btn btn-primary" onClick={openAddModal}>
          + Add Category
        </button>
      </div>

      <ReusableTable
        columns={columns}
        data={categories}
        title="Category List"
      />

      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content rounded-4">
              <div className="modal-header">
                <h4 className="modal-title fw-bold">
                  {editId ? "Edit Category" : "Add Category"}
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              <form onSubmit={formik.handleSubmit}>
                <div className="modal-body">
                  <div className="floating-label">
                    <input
                      type="text"
                      name="name"
                      placeholder=" "
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      required
                    />
                    <label>Category Name</label>
                  </div>

                    <input
                    type="file"
                    className="form-control mb-3"
                    onChange={(e) => setSelectedImage(e.target.files[0])}
                  />

                  {selectedImage && (
                    <img
                      src={URL.createObjectURL(selectedImage)}
                      alt="preview"
                      width="120"
                      className="rounded mb-3 border"
                    />
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>

                  <button type="submit" className="btn btn-success">
                    {editId ? "Update Category" : "Add Category"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryPage;
